import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';
//import { Message } from '@angular/compiler/src/i18n/i18n_ast';
//import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-itfacility-request',
  templateUrl: './itfacility-request.component.html',
  styleUrls: ['./itfacility-request.component.scss']
})
export class ITfacilityRequestComponent implements OnInit {
public add :any={};
public employeedetails:any=[];
  constructor(public appservice:AppService,public toastr:ToastrService) { }//,public datepipe:DatePipe
onSubmit(){
  this.add.createdby=this.appservice.username;
  if(this.add.IR_AccountType!=="BC 365"){
 this.appservice.postTable("api/Transaction/insertItFacilityform",this.add).subscribe((res:any)=>{
  if(res!=""){
    this.toastr.success("The Data Are Saved Successfully")
    this.appservice.goback();
  }
 });}
 else{
  this.appservice.postTable("api/Transaction/insert_Microsoft360_ItFacilityform",this.add).subscribe((res:any)=>{
  if(res!=""){
    this.toastr.success("The Data Are Saved Successfully")
    this.appservice.goback();
  }
 });
 }
}
getITfacility_empid(){
this.appservice.ITfacility_empid=[];
this.appservice.getTable('api/Transaction/GetITfacilityempId').subscribe((res:any)=>{
  this.appservice.ITfacility_empid=JSON.parse(res);
  
})
}
onAccountTypeChange(){
  // if(this.add.IR_AccountType=="BC 365"){
    
  // } else{ this.appservice.getITfacility_empid();}
}
Onempselect(data:any){
  this.appservice.getTable("api/Transaction/ITFacilityempid?empid="+data).subscribe((res:any)=>{
    if(res!=""){
      this.employeedetails=JSON.parse(res).record;
      console.log("the employeedetails of itfacility request form", this.employeedetails)
      if(this.employeedetails && this.employeedetails.length>0){
        let emp =this.employeedetails[0]
      this.add.IR_Fullname = emp.Em_First_Name+' '+emp.Em_lastName;
      this.add.IR_ADUserName = emp.Em_ADUserName;
      this.add.IR_ADMailId = emp.Em_Email;
      this.add.IR_Designation = emp.Em_Designation;
      this.add.IR_Grade = emp.Em_Grade;
      this.add.IR_Department = emp.Em_Department;
      this.add.IR_ReportingId = emp.reportercode;
      this.add.reporterMail =emp.reportermailid
      this.add.IR_ReporterDesignation=emp.reporterdesignation
      this.add.IR_ReporterName = emp.reportname;
      }
      
     }else{
      this.toastr.error("The Employee Id Not Exists");
     }
        });
}
  ngOnInit(): void {
     this.appservice.getITfacility_empid();
     this.add.Companyname="BBLD-NEW";
    // this.add.Requestdate=this.datepipe.transform(new Date(), "yyyy-MM-dd");
     this.add.Requestdate = new Date().toISOString().split('T')[0];
     this.add.Dateofjoin=new Date().toISOString().split('T')[0];
  }

}
